//export const API_BASE_URL = "http://localhost:8888/resetapi/api/v1";
//export const API_BASE_URL = "https://teamshire.com/resetapi/api/v1";
const HOSTNAME = typeof window !== 'undefined' ? window.location.hostname : '';
const isStaging = HOSTNAME.includes("staging");
// Serve the API same-origin per brand domain so both vertivio.com and
// whatisreset.com work without cross-origin. vertivio.com is the primary brand.
const onVertivio = HOSTNAME.endsWith("vertivio.com");
export const API_BASE_URL = onVertivio
    ? (isStaging ? "https://staging-reset-api.vertivio.com/api/v1"
                 : "https://reset-api.vertivio.com/api/v1")
    : (isStaging ? "https://stagingapi.whatisreset.com/api/v1"
                 : "https://api.whatisreset.com/api/v1");
export const LOGIN = API_BASE_URL + "/login";
export const USER_SIGNUP = API_BASE_URL + "/user/register";
export const FORGOT_PASSWORD = API_BASE_URL + "/user/forgotpassword";
export const UPDATE_PASSWORD = API_BASE_URL + "/user/updatepassword";
export const USER_PROFILE = API_BASE_URL + "/user/get";
export const EXPERT_PROFILE = API_BASE_URL + "/expert/get";
export const EXPERT_SIGNUP = API_BASE_URL + "/expert/register";

export const USER_UPDATE_PROFILE = "/user/update";
export const GET_THEME_LIST = "/theme/getall";
export const GET_PACKAGE_LIST = "/package/getall/";
export const GET_ASSESSMENT_LIST = "/assessment/getall/";
export const GET_ASSESSMENT_PROGRESS_LIST = "/assessment/list/";
export const START_ASSESSMENT = "/assessment/start";
export const PURCHASE_PACKAGE = "/user/purchase";
export const EXPERT_PURCHASE_PACKAGE = "/expert/package/purchase";
export const EXPERT_PACKAGE = "/expert/package/get/";
export const GET_PURCHASED_PACKAGES = "/package/purchased";
export const RETAKE_PACKAGE = "/package/retake";
export const CHECKOUT_SESSION = "/payment/create-checkout-session";
export const GET_FIRST_ASSESSMENT = "/assessment/getcore/";
export const GET_NEXT_QUESTION = "/assessment/getNextQuestion";
export const GET_ASSESSMENT_RESULT = "/assessment/result/id/";
export const GET_ASSESSMENT_BY_ID = "/assessment/";
export const GET_ASSESSMENT_BY_NAME = "/assessment/getbyName/";
export const GET_PACKAGE_REPORT = "/user/report/";
export const GET_EXPERT_PACKAGE_LIST = "/theme/packages"
export const GET_EXPERT_USERS_LIST = "/expert/user/users"
// export const GET_EXPERT_USERS_LIST = "/user/users"
export const TICKET_CREATE = "/support/create"
export const GET_TICKET_LIST = "/support/list"
export const GET_EXPERT_TICKET_LIST = "/expert/support/list"
export const GET_EXPERT_RECENT_TICKET_LIST = "/expert/support/recentlist"
export const GET_USER_RECENT_TICKET_LIST = "/user/support/recentlist"
export const GET_SUPPORT_ID_DETAILS = "/support/"
export const SEND_MESSAGE = "/support/send"
export const UPDATE_SUPPORT_TICKET = "/support/updateStatus"
export const EXPERT_ADD_USER = "/expert/user/add"
export const EXPERT_EDIT_USER = "/expert/user/update"
export const EXPERT_DELETE_USER = "/expert/user/delete"
export const EXPERT_GET_USER_DETAILS = "/expert/user/"
export const EXPERT_UPDATE_PASSWORD = "/expert/user/changepassword"
export const EXPERT_GET_DASHBOARD_DETAILS = "/expert/dashboard"
export const EXPERT_THEME_PACKAGES = "/expert/package/purchased/";
export const EXPERT_ASSIGNED_PACKAGES = "/expert/package/assigned/";
export const EXPERT_ASSIGN_PACKAGE = "/expert/package/assign";
export const EXPERT_UNASSIGN_PACKAGE = "expert/package/unassign";
export const REPORT_DOWNLOAD = "/package/download/";
export const CHANGE_PASSWORD = "/user/changepassword";
export const EXPERT_CHECKOUT_SESSION = "/payment/expert/create-checkout-session";
export const EXPERT_REMAINING_LICENSES = "/expert/package/remaininglicenses/";
export const EXPERT_REMOVE_LICENSE = "/expert/package/removelicense";
export const EXPERT_UPDATE_PROFILE = "/expert/update";
export const USER_GET_DASHBOARD_DETAILS = "/user/dashboard"
export const USER_GET_COACH = "/user/coach"

export const USER_FAQS = API_BASE_URL + "/user/faqs";
export const EXPERT_FAQS = API_BASE_URL + "/expert/faqs";

export const GET_ASSESSMENTDETAILS_BY_ID = "/assessment/getbyId/";

export const SAVE_CONTACT = API_BASE_URL + "/contact/save";

// Stripe keys intentionally absent: checkout sessions are created server-side by the API,
// so the client never needs a publishable key. Never put a Stripe secret key here.

// reCAPTCHA SITE key only — this is public by design and safe in client code.
// The matching SECRET key belongs server-side only (Secrets Manager: vertivio/*/recaptcha-secret).
export const REACT_APP_SITE_KEY ="6Lc2rcktAAAAAFlj600v1Z3maUOzvT4zio6vRNxt";

export const GET_TOKEN = API_BASE_URL + "/getToken";

export const ACCESS_TOKEN = 'accessToken';

//export const OAUTH2_REDIRECT_URI = 'http://localhost:3000/oauth2/redirect'
//export const OAUTH2_REDIRECT_URI = 'https://teamshire.com/oauth2/redirect'
export const OAUTH2_REDIRECT_URI = onVertivio
    ? (isStaging ? 'https://staging-reset.vertivio.com/oauth2/redirect'
                 : 'https://reset.vertivio.com/oauth2/redirect')
    : (isStaging ? 'https://stagingapp.whatisreset.com/oauth2/redirect'
                 : 'https://app.whatisreset.com/oauth2/redirect');

export const LOGIN_GOOGLE_AUTH_URL = API_BASE_URL + '/oauth2/authorize/google?account_type=login&user_type=U&redirect_uri=' + OAUTH2_REDIRECT_URI;

export const GOOGLE_AUTH_URL = API_BASE_URL + '/oauth2/authorize/google?account_type=register&user_type=U&redirect_uri=' + OAUTH2_REDIRECT_URI;

export const EXPERT_GOOGLE_AUTH_URL = API_BASE_URL + '/oauth2/authorize/google?account_type=register&user_type=E&redirect_uri=' + OAUTH2_REDIRECT_URI;

export const EXPERT_SAVE_COMPANY = "/expert/saveCompany";

// Content & training engine (CONTENT-MODEL-DESIGN.md section 5). The article
// slug is appended by the caller; engagement is a POST of a single event row.
// Recommendations take ?assessmentId={id} and return the ranked items that
// resolve a result to the training that addresses it.
export const GET_CONTENT_ARTICLE = "/content/articles/";
export const GET_CONTENT_RECOMMENDATIONS = "/content/recommendations";
export const SAVE_CONTENT_ENGAGEMENT = "/content/engagement";

export const VALIDATE_USER_COUPON = "/coupon/validate/user/";
export const VALIDATE_EXPERT_COUPON = "/coupon/validate/expert/";
